import { styled } from "@mui/material/styles";
import { StepConnector, stepConnectorClasses } from "@mui/material";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  // [`&.${stepConnectorClasses.alternativeLabel}`]: {
  //   left: "62%",
  //   right: "-42%",
  //   zIndex: 0,
  // },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(234.07deg, #A5BDFF 0.27%, #0250C1 58.7%, #95E9FF 104.18%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(234.07deg, #A5BDFF 0.27%, #0250C1 58.7%, #95E9FF 104.18%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

export default ColorlibConnector;
